"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var base_1 = require("./base");
var PHPClient = /** @class */ (function (_super) {
    __extends(PHPClient, _super);
    function PHPClient(debug, phpUrl, reqInterceptor, respInterceptorp) {
        if (debug === void 0) { debug = true; }
        var _this = _super.call(this, debug, reqInterceptor, respInterceptorp, {
            withCredentials: true
        }) || this;
        _this.phpUrl = phpUrl;
        return _this;
    }
    PHPClient.prototype.login = function (account, textPwd) {
        var password = this.secret.md5(textPwd);
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Index/login", { account: account, password: password });
    };
    /**
     * 查询城市、热点、门店
     */
    PHPClient.prototype.querySelectList = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/ReserveInterface/querySelectList", data);
    };
    /**
     * 订单来源
     */
    PHPClient.prototype.orderSource = function () {
        return this.prepareGetRequest(this.phpUrl + "Interface/index.php/Home/ReserveInterface/orderSource");
    };
    /***
     * 客服开票订单提交
     */
    PHPClient.prototype.signInvoice = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/signInvoice", data);
    };
    /**
     * 查询订单来源列表
     * @param page
     * @param rows
     * @param filter
     * @param sort
     * @param asc
     */
    PHPClient.prototype.orderSourceList = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/ReserveInterface/orderSourceList", data);
    };
    /**
     * 新增订单来源
     * @param name
     * @param sourceType
     * @param isShow
     * @param status
     * @param remark
     * @param needShortGuarentee
     * @param tip
     * @param invoceConfig
     * @param expression
     */
    PHPClient.prototype.addOrderSource = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/addOrderSource", data);
    };
    /**
     * 编辑订单来源
     * @param id
     * @param name
     * @param sourceType
     * @param isShow
     * @param status
     * @param remark
     * @param needShortGuarentee
     * @param tip
     * @param invoceConfig
     * @param expression
     */
    PHPClient.prototype.editOrderSource = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/editOrderSource", data);
    };
    /**
     * 查询订单列表
     * @param page
     * @param size
     * @param orderNo
     * @param phone
     * @param roomNo
     * @param stat
     * @param sourceType
     * @param payStat
     * @param checkin
     * @param city
     * @param hotspotName
     * @param chainName
     * @param rentType
     * @param orderName
     * @param otherNo
     * @param startDate
     * @param endDate
     */
    PHPClient.prototype.queryOrderDataByDateExt = function (params) {
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/ReserveInterface/queryOrderDataByDateExt", params);
    };
    //////////////////////////// 订单开票管理列表接口 ////////////////////////////////
    PHPClient.prototype.queryInvoiceManageByDate = function (params) {
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/ReserveInterface/queryInvoiceManageByDate", params);
    };
    /**
     * 导出开票管理列表
     */
    PHPClient.prototype.queryInvoiceManageByDateExcelData = function (params) {
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/Reserve/queryInvoiceManageByDateExcelData", params);
    };
    /**
     * 订单添加备注
     * @param orderNo 订单号
     * @param remark 备注内容
     */
    PHPClient.prototype.addRemark = function (orderNo, remark) {
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/addRemark", { orderNo: orderNo, remark: remark });
    };
    /**
     * 查询退款单列表
     * @param startDate
     * @param endDate
     * @param page
     * @param size
     * @param orderNo
     * @param refundStat
     * @param refundType
     * @param refundRea
     * @param refundWay
     */
    PHPClient.prototype.refundsList = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/ReserveInterface/queryRefundsByDate", data);
    };
    /**
     * 新建退款单
     * @param orderNo
     * @param refundType
     * @param price
     * @param reason
     * @param createType
     * @param priceInt
     */
    PHPClient.prototype.createRefund = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/addRefund", data);
    };
    /**
     * 取消退款单
     * @param id
     * @param sourceId
     * @param remark
     */
    PHPClient.prototype.cancelRefund = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/cancelRefund", data);
    };
    /**
     * 手动退款
     * @param id
     * @param sourceId
     * @param payType
     * @param stat
     * @param activeMoney
     * @param refundChannel
     * @param receiveSource
     * @param aliPay
     * @param bankName
     * @param bankCount
     * @param remark
     * @param receiveAccount
     * @param refundAmout
     * @param changeMoney
     * @param tip
     * @param activeMoneyInt
     * @param refundAmoutInt
     */
    PHPClient.prototype.confirmRefund = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/confirmRefund", data);
    };
    /**
     * 查询自用单列表
     * @param beginDate
     * @param endDate
     * @param page
     * @param rows
     */
    PHPClient.prototype.queryOwnerOrderList = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/ReserveInterface/queryOwnerOrderDataByDate", data);
    };
    //////////////////////////// 订单详情相关接口 ////////////////////////////////
    /**
     * 查询自用单列表
     * @param beginDate
     * @param endDate
     * @param page
     * @param rows
     */
    PHPClient.prototype.queryOrderCountByXbedOrderNo = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/CleanerInterface/findOrderCountByXbedOrderNo", data);
    };
    /**
     * 获取权限信息
     * @param menuId
     */
    PHPClient.prototype.getOrderPower = function (menuId) {
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/ReserveInterface/getPowers", "menuId= " + menuId, 'post', false);
    };
    /**
     * 获取入住信息
     * @param checkinId
     */
    PHPClient.prototype.getcheckInfo = function (checkinId) {
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/ReserveInterface/checkinInfoByCheckinId", "checkinId= " + checkinId, 'post', false);
    };
    /**
     * 获取子订单信息
     * @param orderNo
     */
    PHPClient.prototype.getSettlement = function (orderNo) {
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/ReserveInterface/settlement", "orderNo=" + orderNo, 'post', false);
    };
    /**
     * 根据订单号获取订单信息
     * @param orderNo
     */
    PHPClient.prototype.getOrder = function (orderNo) {
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/ReserveInterface/getOrderByOrderNo", "orderNo=" + orderNo, 'post', false);
    };
    /**
     * 代客支付
     * @param data
     */
    PHPClient.prototype.payCheckin = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/payCheckin", data);
    };
    /**
     * 获取退款明细列表
     * @param orderNo
     * @param token
     */
    PHPClient.prototype.queryRefunds = function (orderNo) {
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/ReserveInterface/refund", "orderNo=" + orderNo, 'post', false);
    };
    /**
     * 根据订单号获取支付信息
     * @param orderNo
     */
    PHPClient.prototype.payInfo = function (orderNo) {
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/ReserveInterface/getPayInfo", "orderNo=" + orderNo, 'post', false);
    };
    /**
     * 根据订单号获取订单操作记录
     * @param orderNo
     */
    PHPClient.prototype.getOrderTrail = function (orderNo) {
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/ReserveInterface/orderTrail", "orderNo=" + orderNo, 'post', false);
    };
    /**
     * 添加入住人
     * @param checkinId
     * @param userName
     * @param phone
     */
    PHPClient.prototype.addCustomer = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/checkinAddUser", data);
    };
    /**
     * 删除入住人
     * @param id
     */
    PHPClient.prototype.delCustomer = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/delCheckiner", data);
    };
    /**
     * 办理入住
     * @param checkinId
     * @param infoId
     */
    PHPClient.prototype.checkin = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/checkin", data);
    };
    /**
     * 取消子入住单
     * @param infoId
     */
    PHPClient.prototype.cancleChildOrder = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/cancelChildCheckin", data);
    };
    /**
     * 取消入住单
     * @param checkinId
     * @param remark
     */
    PHPClient.prototype.cancleOrder = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/cancelCheckin", data);
    };
    /**
     * 查询门店
     * @param beginDate
     * @param endDate
     * @param roomId
     * @param checkinId
     */
    PHPClient.prototype.onQueryHotelList = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/ReserveInterface/changeRoomListPrice", data);
    };
    /**
     * 查询房型
     * @param operTypeList  //"operTypeList":["roomType"]
     */
    PHPClient.prototype.onQueryRoomType = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/ReserveInterface/queryModeAndStyleAndType", data);
    };
    /**
     * 查询房间列表
     * @param beginDate
     * @param endDate
     * @param chainId
     * @param roomTypeName
     * @param custRoomNo
     * @param custRoomName
     * @param roomID
     * @param rentType  // 'cnameWay=租赁方式/短租'
     */
    PHPClient.prototype.onQureyRoomList = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/ReserveInterface/queryCanOrderRoom", data);
    };
    /**
     * 更换房间
     * @param roomId,
     * @param checkinId,
     * @param needPayBanlance
     * @param remark
     */
    PHPClient.prototype.changeRoomId = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/changeRoomId", data);
    };
    /**
     * 办理续住（短租）
     * @param checkinId,
     * @param endDate,
     * @param userId
     * @param rentType
     */
    PHPClient.prototype.overStayCalculation = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/Reserve/overstayCalculationCheckin", data);
    };
    /**
     * 差价接口
     * @param data
     */
    PHPClient.prototype.queryDiffPrice = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/ReserveInterface/queryDiffPrice", data);
    };
    /**
     * 获取续住优惠(长租)
     * @param checkinId,
     * @param endDate,
     * @param userId
     * @param source
     * @param rentType
     */
    PHPClient.prototype.queryOverstayDiscount = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/ReserveInterface/queryOverstayDiscount", data);
    };
    /**
     * 提交续住信息
     * @param checkinId,
     * @param endDate,
     * @param userId,
     * @param source,
     * @param rentType,
     * @param price,
     * @param remark,
     */
    PHPClient.prototype.overstayCheckin = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/overstayCheckin", data);
    };
    /**
     * 获取退房押金
     * @param checkinId
     */
    PHPClient.prototype.getCheckOutMoney = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/ReserveInterface/getCheckOutMoney", data);
    };
    /**
     * 立即退房
     * @param checkinId
     * @param realRefundAmount
     * @param bargainMoney
     * @param remark
     */
    PHPClient.prototype.subCheckoutInfo = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/checkout", data);
    };
    /**
     * 查看入住人详情
     * @param mobile
     * @param lodgerId
     */
    PHPClient.prototype.queryLodgerInfo = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/ReserveInterface/queryLodgerInfo", data);
    };
    /**
     * 重置入住单密码
     * @param checkinId
     * @param phone
     */
    PHPClient.prototype.resetPwd = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/resetPwd", data);
    };
    /**
     * 身份验证
     * @param checkinId
     */
    PHPClient.prototype.validateCheckiner = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/orderVerify", data);
    };
    //////////////////////////// 订单详情相关接口end ////////////////////////////////
    /**
     * 获取热点权限id
     */
    PHPClient.prototype.getHotSpotIds = function () {
        return this.prepareGetRequest(this
            .phpUrl + "Interface/index.php/Home/ReserveInterface/getHotspotPowerIds");
    };
    /**
     * 根据roomType 查询mode style type
     */
    PHPClient.prototype.queryModeAndStyleAndType = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/ReserveInterface/queryModeAndStyleAndType", data);
    };
    /**
     * 代下单——获取优惠类型
     */
    PHPClient.prototype.discountType = function () {
        return this.prepareGetRequest(this.phpUrl + "Interface/index.php/Home/ReserveInterface/discountType");
    };
    /**
     * 代下单——查询全部城市
     */
    PHPClient.prototype.queryAllCities = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/ReserveInterface/queryAllCities", data);
    };
    /**
     * 代下单——根据城市和热点ID查询门店
     */
    PHPClient.prototype.queryChainByCity = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/ReserveInterface/queryChainByCity", data);
    };
    /**
     * 代下单接口
     * @param data
     */
    PHPClient.prototype.createNewOrder = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/createNewOrder", data);
    };
    /**
     * 查看开发队伍
     * @param data
     */
    PHPClient.prototype.getDevelopTeam = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/BlueHosterInterface/developerTeam", data);
    };
    /**
     * 修改或新增开发队伍
     * @param data
     */
    PHPClient.prototype.editDeveloperTeam = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/BlueHoster/editDeveloperTeam", data);
    };
    /**
     * 删除开发队伍
     * @param data
     */
    PHPClient.prototype.delDeveloperTeam = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/BlueHoster/delDeveloperTeam", data);
    };
    /**
     * 蓝主任业主列表
     * @param data
     */
    PHPClient.prototype.hosterList = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/BlueHosterInterface/hosterList", data);
    };
    /**
     * 开发员列表
     * @param data
     */
    PHPClient.prototype.developList = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/BlueHosterInterface/developerList", data, 'post');
    };
    //////////////////////////// 会员管理 ///////////////////////////
    /**
     * 获取会员基本信息
     * @param userId
     */
    PHPClient.prototype.queryUserById = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/ReserveInterface/queryUserById", data);
    };
    /**
     * 获取会员推广信息
     * @param userId
     */
    PHPClient.prototype.findUserPromoInfo = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/MarketInterface/findUserPromoInfo", data);
    };
    /**
     * 获取验证码
     * @param phone
     */
    PHPClient.prototype.userValidCode = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/ReserveInterface/userValidCode", data);
    };
    /**
     * 获取省份列表
     * @param
     */
    PHPClient.prototype.provincesList = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/ReserveInterface/provincesData", data);
    };
    /**
     * 获取城市列表
     * @param id
     */
    PHPClient.prototype.cityList = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/ReserveInterface/citysData", data);
    };
    /**
     * 获取区列表
     * @param id
     */
    PHPClient.prototype.countyslist = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/ReserveInterface/countysData", data);
    };
    /**
     * 修改密码
     * @param lodgerId
     * @param password
     * @param rePwd
     */
    PHPClient.prototype.changePwd = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/changeUserInfoPassword", data);
    };
    /**
     * 修改经验值
     * @param userId
     * @param integral
     * @param remark
     */
    PHPClient.prototype.editIntegral = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/editIntegral", data);
    };
    /**
     * 获取会员邮寄地址
     * @param userId
     */
    PHPClient.prototype.userPostAddress = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/ReserveInterface/userAddressData", data);
    };
    /**
     * 增加邮寄地址
     * @param userId
     * @param addressId
     * @param realname
     * @param phone
     * @param title
     * @param province
     * @param city
     * @param county
     * @param address
     * @param code
     */
    PHPClient.prototype.addPostAddress = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/editUserAddress", data);
    };
    /**
     * 删除邮寄地址
     * @param addressId
     */
    PHPClient.prototype.delPostAddress = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/delUserAddress", data);
    };
    /**
     * 查询会员管理列表
     * @param page 页数
     * @param rows 每页数据量
     */
    PHPClient.prototype.queryAllUsers = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/ReserveInterface/queryAllMember", data);
    };
    /**
     * 查询用户来源渠道
     */
    PHPClient.prototype.queryUsersSources = function () {
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/ReserveInterface/queryMemberSourceNode", {});
    };
    /**
     * 修改会员信息
     * @param userId 用户id
     * @param realname 用户名
     * @param email 邮箱
     * @param remark 备注
     */
    PHPClient.prototype.editUser = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/editMember", data);
    };
    /**
     * 修改会员状态
     * @param userId 用户id
     * @param userStat 用户状态
     */
    PHPClient.prototype.editUserState = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/editMemberState", data);
    };
    /**
     * 新增会员
     * @param realname 用户名
     * @param phone 手机号
     * @param sex 性别
     * @param email 邮箱
     * @param mainSource 主渠道
     * @param nodeSource 父渠道(非必填)
     * @param source 子渠道(非必填)
     * @param selectedSource 最后选中的渠道
     * @param remark 备注(非必填)
     */
    PHPClient.prototype.addUser = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/addMember", data);
    };
    //////////////////////////// 会员管理end ///////////////////////////
    //////////////////////////// 入账单列表 ///////////////////////////
    /**
     * 取消入账单
     * @param id
     * @param remark
     */
    PHPClient.prototype.cancelConsumption = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/cancelConsumption", data);
    };
    /**
     * 初始化入账单列表
     * @param id
     * @param remark
     */
    PHPClient.prototype.queryConsumptionsByDate = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/ReserveInterface/queryConsumptionsByDate", data);
    };
    /**
     * 控制子菜单显示对象
     * @param tip
     * @param aliPay
     * @param bankName
     * @param bankCount
     * @param refundAmout
     * @param refundChannel
     */
    PHPClient.prototype.getPowers = function (menuId) {
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/ReserveInterface/getPowers", "menuId=" + menuId, 'post', false);
    };
    /**
     * 定义加载预定渠道的方法
     */
    PHPClient.prototype.orderSourceListAll = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/ReserveInterface/orderSourceListAll", data);
    };
    //////////////////////////// 入账单列表end ///////////////////////////
    ///////////////////////////////// OTA ////////////////////////////////
    /**index.php/Home/OtaInterface/mtChannelHotelList
     * 查询美团渠道门店/房型列表
     * @param data
     */
    PHPClient.prototype.mtChannelHotelList = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/OtaInterface/mtChannelHotelList", data);
    };
    ///////////////////////////////// OTA-END /////////////////////////////
    /**
     * 查询房间信息-->房间排序
     * @param data
     */
    PHPClient.prototype.querySortList = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/AdvertInterface/querySortList", data, 'post', true);
    };
    /**
     * 获取房间排序 热门城市列表
     * @param data
     *
     */
    PHPClient.prototype.queryRoomTagByCname = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/ReserveInterface/queryRoomTagByCname", data, 'post', true);
    };
    /**
     * editSort
     * 房间排序： 修改删除房间
     */
    PHPClient.prototype.editSort = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Advert/editSort", data, 'post', true);
    };
    /**
     *   queryAllRoom
     *
     */
    PHPClient.prototype.queryAllRoom = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/ReserveInterface/queryAllRoom", data);
    };
    /**
     * 添加房间
     * @param data
     */
    PHPClient.prototype.addSortByRoomIds = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Advert/addSortByRoomIds", data, 'post', true);
    };
    /**
     * 获取清洁账单成本及成本的年月
     * @param data
     */
    PHPClient.prototype.billDate = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/CleanerInterface/billDate", data, 'post', true);
    };
    /////////////////////////////oms微信//////////////////////////////
    /**
     * oms-微信获取菜单
     * @param data
     */
    PHPClient.prototype.getMenuList = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/WeChatInterface/menuList", data, 'post');
    };
    /**
     * oms-微信获取父级菜单
     * @param data
     */
    PHPClient.prototype.parentMenuList = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/WeChatInterface/parentMenuList", data, 'post');
    };
    /**
     * oms-微信生成菜单
     * @param data
     */
    PHPClient.prototype.generateMenu = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/WeChat/generateMenu", data, 'post');
    };
    /**
     * oms-微信新增菜单
     * @param data
     */
    PHPClient.prototype.addMenuItem = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/WeChat/addMenu", data, 'post');
    };
    /**
     * oms-微信编辑菜单
     * @param data
     */
    PHPClient.prototype.editMenuItem = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/WeChat/editMenu", data, 'post');
    };
    /**
     * oms-微信删除菜单
     * @param data
     */
    PHPClient.prototype.delMenuItem = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/WeChat/delMenu", data, 'post');
    };
    /**
     * 蓝主人-获取公司信息
     * @param data
     */
    PHPClient.prototype.companyInfo = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/BlueHosterInterface/companyInfo", data, 'post');
    };
    /**
     * 蓝主人-编辑公司信息
     * @param data
     */
    PHPClient.prototype.editCompanyInfo = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/BlueHoster/editCompanyInfo", data, 'post');
    };
    /**
     * 蓝主人-添加公司信息
     * @param data
     */
    PHPClient.prototype.addCompanyInfo = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/BlueHoster/addCompanyInfo", data, 'post');
    };
    /**
     * 蓝主人-添加业主
     * @param data
     */
    PHPClient.prototype.addHoster = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/BlueHoster/addHoster", data, 'post');
    };
    /**
     * 基础数据-添加门店
     * @param data
     */
    PHPClient.prototype.addChain = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/addChain", data, 'post');
    };
    /**
     * 编辑门店
     * @param data
     */
    PHPClient.prototype.editChain = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/editChain", data, 'post');
    };
    /**
     * 基础数据-根据城市查询商圈
     * @param data
     */
    PHPClient.prototype.tagChildList = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this
            .phpUrl + "Interface/index.php/Home/ReserveInterface/queryTagChildList", data, 'post');
    };
    /**
     * 删除门店
     * @param data
     */
    PHPClient.prototype.delChain = function (data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.phpUrl + "Interface/index.php/Home/Reserve/delChain", data, 'post');
    };
    PHPClient.prototype.prepareGetRequest = function (url, data) {
        if (data === void 0) { data = {}; }
        return this.prepareRequest(url, {}, 'get', false, data);
    };
    PHPClient.prototype.prepareRequest = function (url, data, method, stringify, params) {
        if (method === void 0) { method = 'post'; }
        if (stringify === void 0) { stringify = true; }
        var postData = data;
        if (stringify) {
            postData = "json_data=" + JSON.stringify(data);
        }
        return this.fetchPHP(url, method, postData, params);
    };
    return PHPClient;
}(base_1.BaseClient));
exports.PHPClient = PHPClient;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/clients/php-client.js
// module id = 202
// module chunks = 44